<template>
  <div>
    <page :loading="isLoading">
      <rest-list :payload="listEndpoint">
        <template>
          <rest-list-column-date
            prop="create_time"
            :title="$t('TaskHistoryList_Field_CreateTime')"
            :width="200"
          />
          <rest-list-column-enum
            prop="identifier"
            :title="$t('Audiences_SegmentEvaluations_TitleCol')"
            :enum="evaluateIdentifierLabel"
          />
          <rest-list-column-enum
            prop="status"
            :title="$t('TaskHistoryList_Field_Status')"
            :enum="statusLabel"
          />
          <rest-list-column-single-action>
            <template slot-scope="scope">
              <i
                class="el-icon-view"
                @click="fetchTaskData(scope.row.id)"
                v-if="
                  scope.row.status === 2 &&
                    (scope.row.identifier === 'segment_count_recipients' ||
                      scope.row.identifier === 'segment_count_channels' ||
                      scope.row.identifier === 'segment_count_profiles' ||
                      scope.row.identifier === 'segment_count_devices' ||
                      scope.row.identifier === 'segment_rolling_sync')
                "
              />
              <i
                class="el-icon-view"
                @click="fetchTaskData(scope.row.id)"
                v-if="
                  scope.row.status === 2 &&
                    scope.row.identifier === 'segment_preview_recipients' &&
                    $can('UserPersonalData::Read')
                "
              />
              <router-link :to="taskHistoryRoute(scope.row.id)">
                <i
                  class="el-icon-view"
                  v-if="
                    scope.row.identifier === 'segment_rolling_destination_sync'
                  "
                />
              </router-link>
              <i
                class="el-icon-view"
                @click="fatal = true"
                v-if="
                  scope.row.status === 4 &&
                    scope.row.identifier !== 'segment_rolling_destination_sync'
                "
              />
              <i
                class="el-icon-view"
                @click="error = true"
                v-if="
                  scope.row.status === 3 &&
                    scope.row.identifier !== 'segment_rolling_destination_sync'
                "
              />
              <i
                class="el-icon-download"
                @click="downloadExport(scope.row)"
                v-if="
                  scope.row.status === 2 &&
                    $can('UserPersonalData::Export') &&
                    (scope.row.identifier === 'segment_export_devices' ||
                      scope.row.identifier === 'segment_export_profiles' ||
                      scope.row.identifier === 'segment_export_delta')
                "
              />
              <i
                class="el-icon-download"
                @click="exportDelta(scope.row)"
                v-if="canExportDelta(scope.row)"
              />
            </template>
          </rest-list-column-single-action>
        </template>
      </rest-list>
      <members-preview-list-dialog
        :profile-ids="taskData.resultDetails[0].value.recipients"
        :date="dateCreated"
        v-if="taskData && taskData.identifier === 'segment_preview_recipients'"
      />
      <calculate-size-preview-dialog
        v-if="taskData && taskData.identifier === 'segment_count_recipients'"
        :task-data="taskData"
      />
      <calculate-size-preview-dialog
        v-if="taskData && taskData.identifier === 'segment_count_profiles'"
        :task-data="taskData"
      />
      <calculate-size-preview-dialog
        v-if="taskData && taskData.identifier === 'segment_count_devices'"
        :task-data="taskData"
      />
      <channel-reach-preview-dialog
        v-if="taskData && taskData.identifier === 'segment_count_channels'"
        :task-data="taskData"
      />
      <rolling-sync-preview-dialog
        v-if="taskData && taskData.identifier === 'segment_rolling_sync'"
        :task-data="taskData"
      />
      <export-delta-run-dialog
        v-if="showExportDeltaRunDialog"
        :task="exportTaskResult"
        @close="exportDeltaRunHide"
      />
      <fatal-dialog v-if="fatal" />
      <error-dialog v-if="error" />
    </page>
  </div>
</template>

<script>
import RestList from '@/common/components/rest/RestList'
import { projectEndpoint, projectRoute } from '@/core/helpers'
import RestListColumnEnum from '@/common/components/rest/RestListColumnEnum'
import RestListColumnDate from '@/common/components/rest/RestListColumnDate'
import {
  evaluateTaskIdentifierLabel as evaluateIdentifierLabel,
  taskStatusEnum as statusEnum,
  taskStatusLabel as statusLabel
} from '@/modules/tasks/enum/TaskRecordEnums'
import RestListColumnSingleAction from '@/common/components/rest/RestListColumnSingleAction'
import MembersPreviewListDialog from '@/modules/audiences/components/MembersPreviewListDialog'
import RestApi from '@/core/services/RestApi'
import { EventBus } from '@/core/EventBus'
import CalculateSizePreviewDialog from '@/modules/audiences/components/CalculateSizePreviewDialog'
import moment from 'moment'
import Page from '@/common/components/page/Page'
import ChannelReachPreviewDialog from '@/modules/audiences/components/ChannelReachPreviewDialog'
import RollingSyncPreviewDialog from '@/modules/audiences/components/RollingSyncPreviewDialog'
import FatalDialog from '@/modules/audiences/components/FatalDialog'
import ErrorDialog from '@/modules/audiences/components/ErrorDialog'
import ExportDeltaRunDialog from '@/modules/audiences/components/ExportDeltaRunDialog'
import fileDownloadMixin from '@/modules/audiences/mixins/fileDownloadMixin'
import taskPollingMixin from '@/modules/audiences/mixins/taskPollingMixin'
export default {
  name: 'SegmentEvaluations',
  mixins: [fileDownloadMixin, taskPollingMixin],
  components: {
    ExportDeltaRunDialog,
    ErrorDialog,
    FatalDialog,
    ChannelReachPreviewDialog,
    RollingSyncPreviewDialog,
    Page,
    CalculateSizePreviewDialog,
    MembersPreviewListDialog,
    RestListColumnSingleAction,
    RestList,
    RestListColumnEnum,
    RestListColumnDate
  },
  mounted() {
    this.fetchFirstEvaluationId()
    EventBus.$on('members-preview-list-close', this.resetTaskData)
    EventBus.$on('close-calculate-size-preview-dialog', this.resetTaskData)
    EventBus.$on('close-channel-reach-preview-dialog', this.resetTaskData)
    EventBus.$on('close-rolling-sync-preview-dialog', this.resetTaskData)
    EventBus.$on('fatal-ok', () => {
      this.fatal = false
    })
    EventBus.$on('error-ok', () => {
      this.error = false
    })
  },
  destroyed() {
    EventBus.$off('close-calculate-size-preview-dialog')
    EventBus.$off('close-channel-reach-preview-dialog')
    EventBus.$off('close-rolling-sync-preview-dialog')
    EventBus.$off('fatal-ok')
    EventBus.$off('error-ok')
  },
  data() {
    return {
      statusEnum,
      evaluateIdentifierLabel,
      statusLabel,
      taskData: null,
      isLoading: false,
      fatal: false,
      error: false,
      showExportDeltaRunDialog: false,
      firstEvaluationId: null
    }
  },
  methods: {
    downloadExport(task) {
      this.downloadTaskFile(task)
    },
    /**
     * The initial rolling sync populates the segment from empty, so every
     * member comes back as "added" and delta_available is true just like any
     * later evaluation. That first "delta" is really the whole segment, so the
     * export is offered from the second evaluation onwards.
     */
    canExportDelta(row) {
      return (
        row.status === 2 &&
        row.identifier === 'segment_rolling_sync' &&
        !this.isFirstEvaluation(row) &&
        row.task &&
        row.task.results &&
        row.task.results.delta_available === true &&
        this.$can('UserPersonalData::Export')
      )
    },
    isFirstEvaluation(row) {
      return (
        this.firstEvaluationId !== null &&
        String(row.id) === String(this.firstEvaluationId)
      )
    },
    /**
     * The evaluations list is paginated newest-first, so the earliest
     * evaluation is not necessarily on the page being viewed. Ask the API for
     * it directly instead. Only completed syncs count: if the very first
     * attempt failed the segment stayed empty, which makes the first
     * successful sync the one that populated it.
     */
    fetchFirstEvaluationId() {
      RestApi(
        projectEndpoint({
          method: 'get',
          url: `task-histories`,
          params: {
            segment_id: this.$route.query.id,
            identifier: 'segment_rolling_sync',
            status: 2,
            sort: 'create_time',
            'per-page': 1
          }
        })
      )
        .then(({ data }) => {
          this.firstEvaluationId = data && data.length ? data[0].id : null
        })
        .catch(() => {
          // Without this id we cannot tell which evaluation was the initial
          // population, so leave the action visible rather than hiding a
          // legitimate export on every row.
          this.firstEvaluationId = null
        })
    },
    exportDelta(row) {
      this.showExportDeltaRunDialog = true
      this.startExportTaskPolling(this.exportDeltaEndpoint.url, {
        task_record_id: row.id
      }).catch(error => {
        this.showExportDeltaRunDialog = false
        this.$message({
          message: error.message,
          type: 'error'
        })
      })
    },
    exportDeltaRunHide() {
      this.showExportDeltaRunDialog = false
      this.stopExportTaskPolling()
    },
    resetTaskData() {
      this.taskData = false
    },
    taskEndpoint() {
      projectEndpoint({
        method: 'get',
        url: `task-histories/${this.$route.query.id}?expand=task`
      })
    },
    fetchTaskData(taskId) {
      this.isLoading = true
      RestApi(
        projectEndpoint({
          method: 'get',
          url: `task-histories/${taskId}?expand=task,resultDetails`
        })
      )
        .then(({ data }) => {
          this.isLoading = false
          this.taskData = data
        })
        .catch(error => {
          this.isLoading = false
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    },
    taskHistoryRoute(id) {
      return projectRoute({
        name: 'TaskHistoryView',
        query: { id: id }
      })
    }
  },
  computed: {
    dateCreated() {
      return this.taskData
        ? moment(this.taskData.create_time * 1000).format('DD-MMM-YYYY HH:mm')
        : null
    },
    listEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `task-histories`,
        params: {
          expand: 'task',
          sort: '-create_time',
          segment_id: this.$route.query.id
        }
      })
    },
    exportDeltaEndpoint() {
      return projectEndpoint({
        url: `segment-evaluate/export-delta`
      })
    }
  },
  watch: {
    exportTaskResult: {
      handler(result) {
        if (result && result.status !== undefined) {
          this.handleExportTaskStatus(
            () => {},
            () => {
              this.$message({
                message: this.$t('Audiences_Segment_Alert_Error'),
                type: 'error'
              })
              this.exportDeltaRunHide()
            }
          )
        }
      },
      deep: true
    }
  }
}
</script>
<style scoped>
.el-icon-view,
.el-icon-download {
  cursor: pointer;
}
>>> .el-loading-spinner {
  top: 250px;
}
</style>



// WEBPACK FOOTER //
// src/modules/audiences/pages/SegmentTabEvaluations.vue